// @flow
import React from 'react';
import styled from 'styled-components';
import { media } from 'styles/Mixins';
import { Auth } from 'utils/ExportCommon';

const BoxMessage = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 100;
  background: #${props => (props.isHomie ? '278C7E' : '000000')};
  box-shadow: 0 1px 1px 0 rgba(153, 153, 153, 0.5);
  height: 35px;
  width: 100%;
  display: table;
  transition: all ease 1.5s;
  opacity: ${props => (props.visible ? '1' : '0')};
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  transform: ${props => (props.visible ? 'initial' : 'translateY(-40px)')};

  ${media.md`
    ${props => props.isHomie && 'width: 1024px;'}
    height: 35px;
    margin: 0 auto;
  `};
`;

const Message = styled.p`
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  line-height: 15px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  width: 100%;
`;

const WrapperIcon = styled.div`
  display: ${props => (props.visibleIcon ? 'inline-block' : 'none')};
`;

const IconWhatsapp = styled.img.attrs({
  src: Auth.wsapp
})`
  margin: 0 10px;
`;

const WrapperMessage = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

type PropsType = {
  timer: number,
  message: string,
  visible: boolean,
  visibleIcon: boolean,
  closeMessageAction: () => void,
  isHomie: boolean
};

export default class MessageFlash extends React.Component<PropsType> {
  static defaultProps = {
    timer: 5000,
    message: '',
    visible: true,
    visibleIcon: false,
    isHomie: true,
    closeMessageAction: () => {}
  };

  constructor(props: PropsType) {
    super(props);
    this.timerID = null;
  }

  componentDidMount() {
    this.timerID = setTimeout(this.closeAction, this.props.timer);
  }

  clearTimer = () => {
    if (this.timerID) {
      clearTimeout(this.timerID);
    }
  };

  closeAction = () => {
    this.clearTimer();
    this.props.closeMessageAction();
  };

  render() {
    const { isHomie, visible, visibleIcon, message } = this.props;
    return (
      <BoxMessage isHomie={isHomie} visible={visible}>
        <WrapperMessage>
          <WrapperIcon visibleIcon={visibleIcon}>
            <IconWhatsapp />
          </WrapperIcon>
          <Message>{message}</Message>
        </WrapperMessage>
      </BoxMessage>
    );
  }
}
